
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { FormControlLabel, IconButton } from '@material-ui/core';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';

const useStyles = makeStyles(theme => ({
  dialogDiv: {
    padding: 20
  },
  closeDiv: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 20
  }
}));


function SimpleDialog(props) {
  const classes = useStyles();

  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleChange = (event) => {
    onClose(event.target.value);
  };

  return (

    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title"
      open={open}
    >

      <div className={classes.closeDiv}>
        <DialogTitle id="simple-dialog-title">Would you like this</DialogTitle>
        <IconButton color="inherit">
          <CancelPresentationIcon onClick={handleClose} />
        </IconButton>
      </div>
      <div className={classes.dialogDiv}>
        <RadioGroup aria-label="gender" name="select your opinion" value={selectedValue} onChange={handleChange}>
          <FormControlLabel value="Interested" control={<Radio />} label="Interested" />
          <FormControlLabel value="Not Interested" control={<Radio />} label="Not Interested" />
          <FormControlLabel value="Tentative" control={<Radio />} label="Tentative" />
          <FormControlLabel value="Not Relevent" control={<Radio />} label="Not Relevent" />
        </RadioGroup>
      </div>

    </Dialog>

  );
}

export default SimpleDialog

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

